import { c as create_ssr_component, s as spread, b as escape_object, a as escape_attribute_value, h as setContext, g as getContext, f as createEventDispatcher, o as onDestroy, d as add_attribute, v as validate_component, i as each, e as escape } from "../../../../../chunks/ssr.js";
import { T as Tabs, a as TabItem } from "../../../../../chunks/Tabs.js";
import { c as contractVariables } from "../../../../../chunks/TipTapEditor.js";
import { B as Button } from "../../../../../chunks/Button.js";
import { F as Fileupload } from "../../../../../chunks/Fileupload.js";
import { S as Search } from "../../../../../chunks/Search.js";
import { S as Select } from "../../../../../chunks/Select.js";
import { M as Modal } from "../../../../../chunks/Modal2.js";
import { r as retire } from "../../../../../chunks/api.js";
import { S as SortableTable } from "../../../../../chunks/SortableTable.js";
import { c as contractTypes } from "../../../../../chunks/contractTypes.js";
import { O as OpenButton } from "../../../../../chunks/OpenButton.js";
import { R as RemoveButton } from "../../../../../chunks/RemoveButton.js";
import { E as EditButton } from "../../../../../chunks/EditButton.js";
import { L as Label } from "../../../../../chunks/Label.js";
import Konva from "konva";
import { c as compute_rest_props, s as subscribe } from "../../../../../chunks/utils.js";
import { w as writable } from "../../../../../chunks/index2.js";
import { I as Input } from "../../../../../chunks/Input.js";
import { C as CirclePlusSolid } from "../../../../../chunks/CirclePlusSolid.js";
import { C as Card } from "../../../../../chunks/Card.js";
import { T as Textarea } from "../../../../../chunks/Textarea.js";
import { twMerge } from "tailwind-merge";
import { H as Heading } from "../../../../../chunks/Heading.js";
import { H as Hr } from "../../../../../chunks/Hr.js";
import { I as InfoBox } from "../../../../../chunks/InfoBox.js";
import { g as globalToast } from "../../../../../chunks/toast2.js";
import "dayjs";
import { g as globalConfirm } from "../../../../../chunks/modal.js";
const ArrowKeyRight = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$restProps = compute_rest_props($$props, ["svgClass"]);
  let { svgClass = "w-4 h-4" } = $$props;
  if ($$props.svgClass === void 0 && $$bindings.svgClass && svgClass !== void 0) $$bindings.svgClass(svgClass);
  return `<svg${spread(
    [
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge(svgClass, $$props.class))
      },
      { "aria-hidden": "true" },
      { fill: "currentColor" },
      { xmlns: "http://www.w3.org/2000/svg" },
      { viewBox: "0 0 320 512" }
    ],
    {}
  )}><path d="M118.6 105.4l128 127.1C252.9 239.6 256 247.8 256 255.1s-3.125 16.38-9.375 22.63l-128 127.1c-9.156 9.156-22.91 11.9-34.88 6.943S64 396.9 64 383.1V128c0-12.94 7.781-24.62 19.75-29.58S109.5 96.23 118.6 105.4z"></path></svg> `;
});
const deleteDocumentTemplate = async (document) => {
  return await retire("/template-document/" + document.id);
};
const mailTemplateLevels = [
  { value: "system", name: "System", stati: [] },
  { value: "candidate", name: "Bewerber", stati: ["candidate", "interviewee", "telephone-interview", "data-requested", "date-provided", "data-verified", "training-session", "training-verified"] },
  { value: "contractible", name: "MA Vertragsfähig", stati: ["offered", "onboarding", "rebuddy", "data-re-requested", "data-re-provided", "re-offered", "inactive"] },
  { value: "active", name: "Aktive Mitarbeiter", stati: ["active"] },
  { value: "retiring", name: "Auflösung/Kündigung", stati: ["active", "inactive"] },
  { value: "customer", name: "Kunde", stati: [] },
  { value: "import", name: "Immer & Import", stati: ["*"] }
];
let mailTemplates = (toggleModal, toggleDelete) => [
  {
    label: "Name",
    property: "name",
    sortable: true
  },
  {
    label: "Verfügbarkeit",
    property: "level",
    render: (item) => mailTemplateLevels.find((x) => x.value === item.level)?.name || item.level
  },
  {
    label: "Platzhalter",
    property: "placeholders",
    render: (item) => `<p class="max-w-[400px] whitespace-normal">${item.placeholders.map((x) => x.templateProperty).join(", ")}</p>`,
    class: "w-1/4"
  },
  {
    label: "Delete",
    property: "id",
    component: RemoveButton,
    props: {
      onClick: (id) => {
        toggleDelete(id);
      },
      classes: "text-center"
    }
  },
  {
    label: "Edit",
    property: "id",
    component: EditButton,
    props: {
      onClick: (id) => {
        toggleModal(id);
      },
      classes: "text-center"
    },
    class: "w-8"
  }
];
const contractTemplates = (deleteFunction, editFunction, newVersionFunction) => [
  {
    label: "Type",
    property: "contractType",
    render: (contract) => contractTypes.find((x) => x.value === contract.contractType)?.name
  },
  {
    label: "Name",
    property: "name"
  },
  {
    label: "Edit",
    property: "id",
    component: EditButton,
    props: {
      onClick: (id) => {
        editFunction(id);
      }
    }
  },
  {
    label: "New Version",
    property: "id",
    component: EditButton,
    props: {
      onClick: (id) => {
        newVersionFunction(id);
      }
    }
  },
  {
    label: "Download",
    property: "location",
    component: OpenButton,
    props: {
      onClick: (loc) => window ? window.open(loc, "_blank")?.focus() : null
    }
  },
  {
    label: "Entfernen",
    property: "id",
    component: RemoveButton,
    props: {
      onClick: (id) => {
        deleteFunction(id);
      }
    }
  }
];
const CONTAINER_COMPONENT_KEYS = [
  "svelte-konva-stage",
  "svelte-konva-layer",
  "svelte-konva-group",
  "svelte-konva-label"
];
var Container;
(function(Container2) {
  Container2[Container2["Stage"] = 0] = "Stage";
  Container2[Container2["Layer"] = 1] = "Layer";
  Container2[Container2["Group"] = 2] = "Group";
  Container2[Container2["Label"] = 3] = "Label";
})(Container || (Container = {}));
const CONTAINER_ERROR = "svelte-konva: Component does not have any parent container. Please make sure that the component is wrapped inside a Layer or Group.";
const LAYER_ERROR = "svelte-konva: A Layer needs to have a Stage as parent.";
function setContainerContext(kind, value) {
  CONTAINER_COMPONENT_KEYS.forEach((key) => {
    setContext(key, null);
  });
  setContext(CONTAINER_COMPONENT_KEYS[kind], value);
}
function getParentContainer() {
  for (let i = 1; i < 4; i++) {
    const parent = getContext(CONTAINER_COMPONENT_KEYS[i]);
    if (parent) {
      return parent;
    }
  }
  throw new Error(CONTAINER_ERROR);
}
function getParentStage() {
  const parent = getContext(CONTAINER_COMPONENT_KEYS[Container.Stage]);
  if (parent) {
    return parent;
  }
  throw new Error(LAYER_ERROR);
}
const Image = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$unsubscribe_parent;
  let { config } = $$props;
  let { handle = new Konva.Image(config) } = $$props;
  let { staticConfig = false } = $$props;
  let parent = getParentContainer();
  $$unsubscribe_parent = subscribe(parent, (value) => value);
  createEventDispatcher();
  onDestroy(() => {
    handle.destroy();
  });
  if ($$props.config === void 0 && $$bindings.config && config !== void 0) $$bindings.config(config);
  if ($$props.handle === void 0 && $$bindings.handle && handle !== void 0) $$bindings.handle(handle);
  if ($$props.staticConfig === void 0 && $$bindings.staticConfig && staticConfig !== void 0) $$bindings.staticConfig(staticConfig);
  {
    handle.setAttrs(config);
  }
  $$unsubscribe_parent();
  return ``;
});
const Layer = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$unsubscribe_parent;
  let { config = {} } = $$props;
  let { handle = new Konva.Layer(config) } = $$props;
  let { staticConfig = false } = $$props;
  let inner = writable(null);
  createEventDispatcher();
  let parent = getParentStage();
  $$unsubscribe_parent = subscribe(parent, (value) => value);
  onDestroy(() => {
    if (handle) {
      handle.destroy();
    }
  });
  setContainerContext(Container.Layer, inner);
  if ($$props.config === void 0 && $$bindings.config && config !== void 0) $$bindings.config(config);
  if ($$props.handle === void 0 && $$bindings.handle && handle !== void 0) $$bindings.handle(handle);
  if ($$props.staticConfig === void 0 && $$bindings.staticConfig && staticConfig !== void 0) $$bindings.staticConfig(staticConfig);
  {
    if (handle) {
      handle.setAttrs(config);
    }
  }
  $$unsubscribe_parent();
  return `  ${``}`;
});
const Rect = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$unsubscribe_parent;
  let { config } = $$props;
  let { handle = new Konva.Rect(config) } = $$props;
  let { staticConfig = false } = $$props;
  let parent = getParentContainer();
  $$unsubscribe_parent = subscribe(parent, (value) => value);
  createEventDispatcher();
  onDestroy(() => {
    handle.destroy();
  });
  if ($$props.config === void 0 && $$bindings.config && config !== void 0) $$bindings.config(config);
  if ($$props.handle === void 0 && $$bindings.handle && handle !== void 0) $$bindings.handle(handle);
  if ($$props.staticConfig === void 0 && $$bindings.staticConfig && staticConfig !== void 0) $$bindings.staticConfig(staticConfig);
  {
    handle.setAttrs(config);
  }
  $$unsubscribe_parent();
  return ``;
});
const Stage = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$restProps = compute_rest_props($$props, ["config", "handle", "staticConfig"]);
  let { config } = $$props;
  let { handle = null } = $$props;
  let { staticConfig = false } = $$props;
  let inner = writable(null);
  let stage;
  createEventDispatcher();
  onDestroy(() => {
    if (handle) {
      handle.destroy();
    }
  });
  setContainerContext(Container.Stage, inner);
  if ($$props.config === void 0 && $$bindings.config && config !== void 0) $$bindings.config(config);
  if ($$props.handle === void 0 && $$bindings.handle && handle !== void 0) $$bindings.handle(handle);
  if ($$props.staticConfig === void 0 && $$bindings.staticConfig && staticConfig !== void 0) $$bindings.staticConfig(staticConfig);
  {
    if (handle) {
      handle.setAttrs(config);
    }
  }
  return `  <div${spread([escape_object($$restProps)], {})}${add_attribute("this", stage, 0)}>${``}</div>`;
});
const Transformer = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$unsubscribe_parent;
  let { config = {} } = $$props;
  let { handle = new Konva.Transformer(config) } = $$props;
  let { staticConfig = false } = $$props;
  let parent = getParentContainer();
  $$unsubscribe_parent = subscribe(parent, (value) => value);
  createEventDispatcher();
  onDestroy(() => {
    if (handle) {
      handle.destroy();
    }
  });
  if ($$props.config === void 0 && $$bindings.config && config !== void 0) $$bindings.config(config);
  if ($$props.handle === void 0 && $$bindings.handle && handle !== void 0) $$bindings.handle(handle);
  if ($$props.staticConfig === void 0 && $$bindings.staticConfig && staticConfig !== void 0) $$bindings.staticConfig(staticConfig);
  {
    if (handle) {
      handle.setAttrs(config);
    }
  }
  $$unsubscribe_parent();
  return ``;
});
const ContractCanvas = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { image = null } = $$props;
  let { page = 1 } = $$props;
  let { contract } = $$props;
  let { fields = [] } = $$props;
  let contractCanvas = null;
  let transformer;
  let selectedShapeName = "";
  let localFields = [];
  if ($$props.image === void 0 && $$bindings.image && image !== void 0) $$bindings.image(image);
  if ($$props.page === void 0 && $$bindings.page && page !== void 0) $$bindings.page(page);
  if ($$props.contract === void 0 && $$bindings.contract && contract !== void 0) $$bindings.contract(contract);
  if ($$props.fields === void 0 && $$bindings.fields && fields !== void 0) $$bindings.fields(fields);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `<div class="flex gap-2 mt-7">${validate_component(Button, "Button").$$render($$result, { class: "block mb-1 whitespace-nowrap" }, {}, {
      default: () => {
        return `Signature: employee`;
      }
    })} ${validate_component(Button, "Button").$$render($$result, { class: "block mb-1" }, {}, {
      default: () => {
        return `Signature: company`;
      }
    })} ${validate_component(Button, "Button").$$render(
      $$result,
      {
        color: "alternative",
        class: "block mb-1"
      },
      {},
      {
        default: () => {
          return `Text: company`;
        }
      }
    )} ${validate_component(Button, "Button").$$render(
      $$result,
      {
        color: "alternative",
        class: "block mb-1"
      },
      {},
      {
        default: () => {
          return `Text: employee`;
        }
      }
    )} ${validate_component(Button, "Button").$$render($$result, { outline: true, class: "block mb-1" }, {}, {
      default: () => {
        return `Date: company`;
      }
    })} ${validate_component(Button, "Button").$$render($$result, { outline: true, class: "block mb-1" }, {}, {
      default: () => {
        return `Date: employee`;
      }
    })}</div> <div class="flex gap-3 w-full"><div class="flex-1"${add_attribute("this", contractCanvas, 0)}>${validate_component(Stage, "Stage").$$render(
      $$result,
      {
        config: {
          width: contractCanvas?.offsetWidth,
          height: image?.height
        }
      },
      {},
      {
        default: () => {
          return `${validate_component(Layer, "Layer").$$render($$result, {}, {}, {
            default: () => {
              return `${validate_component(Image, "Image").$$render($$result, { config: { image } }, {}, {})} ${each(localFields, (rectangle) => {
                return `${validate_component(Rect, "Rect").$$render($$result, { config: rectangle }, {}, {})}`;
              })} ${validate_component(Transformer, "Transformer").$$render(
                $$result,
                { handle: transformer },
                {
                  handle: ($$value) => {
                    transformer = $$value;
                    $$settled = false;
                  }
                },
                {}
              )}`;
            }
          })}`;
        }
      }
    )}</div> <div class="w-64"><p>${escape(selectedShapeName)}</p> ${each(localFields, (rectangle) => {
      return `<div class="flex gap-5 items-center"><div class="w-5 h-5" style="${"background: " + escape(rectangle.fill, true)}"></div> <div>${escape(rectangle.type)}</div> <div>${validate_component(Button, "Button").$$render($$result, { size: "xs", color: "red" }, {}, {
        default: () => {
          return `x`;
        }
      })} </div></div> <div class="grid grid-cols-2 mb-5"><div>x: ${escape(rectangle.x.toFixed(1))}</div> <div>y: ${escape(rectangle.y.toFixed(1))}</div> <div>width: ${escape((rectangle.width * (rectangle.scaleX ?? 1)).toFixed(1))}</div> <div>height: ${escape((rectangle.height * (rectangle.scaleY ?? 1)).toFixed(1))}</div> <div class="col-span-2">${validate_component(Input, "Input").$$render(
        $$result,
        {
          placeholder: "Label",
          value: rectangle.label
        },
        {
          value: ($$value) => {
            rectangle.label = $$value;
            $$settled = false;
          }
        },
        {}
      )}</div> </div>`;
    })}</div></div>`;
  } while (!$$settled);
  return $$rendered;
});
const ContractFields = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { contract } = $$props;
  let activePage = 1;
  let image = null;
  if ($$props.contract === void 0 && $$bindings.contract && contract !== void 0) $$bindings.contract(contract);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `<section><h3 class="font-bold">${escape(contract.name)}</h3> <div class="flex gap-3"><div class="w-36">${validate_component(Label, "Label").$$render($$result, { class: "space-y-2" }, {}, {
      default: () => {
        return `<span data-svelte-h="svelte-1ct7bwx">Page</span> ${validate_component(Select, "Select").$$render(
          $$result,
          { placeholder: "Page", value: activePage },
          {
            value: ($$value) => {
              activePage = $$value;
              $$settled = false;
            }
          },
          {
            default: () => {
              return `${each(contract.bitmaps, (bitmap) => {
                return `<option${add_attribute("value", bitmap.page, 0)}>Page ${escape(bitmap.page)}</option>`;
              })}`;
            }
          }
        )}`;
      }
    })}</div> <div class="flex-1 relative">${`${validate_component(ContractCanvas, "ContractCanvas").$$render(
      $$result,
      {
        image,
        contract,
        page: activePage,
        fields: contract.fields
      },
      {
        fields: ($$value) => {
          contract.fields = $$value;
          $$settled = false;
        }
      },
      {}
    )}`}</div></div></section>`;
  } while (!$$settled);
  return $$rendered;
});
const ContractTemplates = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let showPlaceholder = false;
  let showContractModal = false;
  let templates = [];
  let files = [];
  let contractType;
  let selectedContract;
  let newVersionModal = false;
  let uploadModal = false;
  let search = "";
  const deleteTemplate = async (id) => {
    await deleteDocumentTemplate(templates.find((x) => x.id === id));
    templates = [...templates.filter((x) => x.id !== id)];
  };
  const editFields = async (id) => {
    selectedContract = templates.find((x) => x.id === id);
    showContractModal = true;
  };
  const newVersionProcess = async (id) => {
    selectedContract = templates.find((x) => x.id === id);
    newVersionModal = true;
  };
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `<div class="flex gap-3">${validate_component(Search, "Search").$$render(
      $$result,
      { value: search },
      {
        value: ($$value) => {
          search = $$value;
          $$settled = false;
        }
      },
      {}
    )} <div>${validate_component(Button, "Button").$$render($$result, {}, {}, {
      default: () => {
        return `${validate_component(CirclePlusSolid, "CirclePlusSolid").$$render($$result, {}, {}, {})}`;
      }
    })}</div></div> ${validate_component(Modal, "Modal").$$render(
      $$result,
      {
        size: "xl",
        title: "Vorlage erstellen",
        open: uploadModal
      },
      {
        open: ($$value) => {
          uploadModal = $$value;
          $$settled = false;
        }
      },
      {
        default: () => {
          return `<form class="flex gap-3 mt-3"><div>${validate_component(Button, "Button").$$render($$result, { color: "alternative" }, {}, {
            default: () => {
              return `Show placeholder`;
            }
          })}</div> <div class="flex-1">${validate_component(Fileupload, "Fileupload").$$render(
            $$result,
            {
              placeholder: "Word Vorlage",
              required: true,
              files
            },
            {
              files: ($$value) => {
                files = $$value;
                $$settled = false;
              }
            },
            {}
          )}</div> <div>${validate_component(Select, "Select").$$render(
            $$result,
            {
              placeholder: "Vertragsart",
              items: contractTypes,
              required: true,
              value: contractType
            },
            {
              value: ($$value) => {
                contractType = $$value;
                $$settled = false;
              }
            },
            {}
          )}</div> <div>${`${validate_component(Button, "Button").$$render($$result, { type: "submit" }, {}, {
            default: () => {
              return `upload`;
            }
          })}`}</div></form>`;
        }
      }
    )} ${validate_component(SortableTable, "SortableTable").$$render(
      $$result,
      {
        data: templates.filter((x) => x.templateType === "contract"),
        header: contractTemplates(deleteTemplate, editFields, newVersionProcess)
      },
      {},
      {}
    )} ${validate_component(Modal, "Modal").$$render(
      $$result,
      {
        title: "Neue Version",
        open: newVersionModal
      },
      {
        open: ($$value) => {
          newVersionModal = $$value;
          $$settled = false;
        }
      },
      {
        default: () => {
          return `<p>Neue Version erstellen: ${escape(selectedContract.name)} <span class="text-sm">(${escape(selectedContract.contractType)})</span></p> <div class="flex gap-3">${validate_component(Fileupload, "Fileupload").$$render(
            $$result,
            {
              class: "flex-1",
              placeholder: "Word Vorlage",
              required: true,
              files
            },
            {
              files: ($$value) => {
                files = $$value;
                $$settled = false;
              }
            },
            {}
          )} ${validate_component(Button, "Button").$$render($$result, {}, {}, {
            default: () => {
              return `upload`;
            }
          })}</div>`;
        }
      }
    )} ${validate_component(Modal, "Modal").$$render(
      $$result,
      {
        size: "xl",
        title: "Vertragsvorlage",
        open: showContractModal
      },
      {
        open: ($$value) => {
          showContractModal = $$value;
          $$settled = false;
        }
      },
      {
        default: () => {
          return `${showContractModal ? `${validate_component(ContractFields, "ContractFields").$$render(
            $$result,
            { contract: selectedContract },
            {
              contract: ($$value) => {
                selectedContract = $$value;
                $$settled = false;
              }
            },
            {}
          )}` : ``}`;
        }
      }
    )} ${validate_component(Modal, "Modal").$$render(
      $$result,
      {
        title: "Placeholder",
        open: showPlaceholder
      },
      {
        open: ($$value) => {
          showPlaceholder = $$value;
          $$settled = false;
        }
      },
      {
        default: () => {
          return `${each(Object.keys(contractVariables), (key) => {
            return `<p>${escape(contractVariables[key])}</p>`;
          })}`;
        }
      }
    )}`;
  } while (!$$settled);
  return $$rendered;
});
const EmailTemplateEditModal = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$unsubscribe_globalToast;
  $$unsubscribe_globalToast = subscribe(globalToast, (value) => value);
  let { open = false } = $$props;
  let { template = {
    id: null,
    subject: "",
    name: "",
    level: "",
    content: "",
    placeholders: []
  } } = $$props;
  let previewParts = [];
  createEventDispatcher();
  const formatters = [
    { value: void 0, name: "Kein Formatierung" },
    { value: "date", name: "Datum" },
    { value: "time", name: "Uhrzeit" },
    { value: "currency", name: "Eurobetrag" },
    {
      value: "matcher",
      name: "Key/Value-Matcher"
    },
    { value: "link", name: "Link" }
  ];
  const entities = [
    {
      name: "Employee",
      value: "Employee",
      properties: [
        {
          value: "identityCode",
          name: "Verification Code"
        },
        {
          value: "employeeNumber",
          name: "Personalnummer"
        },
        { value: "firstName", name: "Vorname" },
        { value: "lastName", name: "Nachname" },
        { value: "name", name: "Voller Name" },
        { value: "email", name: "E-Mail" },
        { value: "mobile", name: "Mobilfunknummer" },
        { value: "status", name: "Status" },
        {
          value: "uuid",
          name: "Globale Identifikationsnummer"
        },
        { value: "unit.name", name: "Unit Name" },
        { value: "unit.email", name: "Unit Email" },
        {
          value: "nationality",
          name: "Nationalität"
        },
        {
          value: "dateOfBirth",
          name: "Geburtsdatum"
        }
      ]
    },
    {
      name: "Arbeitsvertrag",
      value: "Contract",
      properties: [
        { value: "hiredAs", name: "Angestellt als" },
        {
          value: "startDate",
          name: "Beginn der Anstellung"
        },
        { value: "endDate", name: "Vertragsende" },
        {
          value: "qualification.title",
          name: "Qualification"
        },
        {
          value: "workDaysPerWeek",
          name: "Wochenarbeitstage"
        },
        {
          value: "workHoursPerDay",
          name: "Arbeitsstunden pro Tag"
        },
        {
          value: "monthlyHours",
          name: "Arbeitsstunden pro Monat"
        },
        { value: "ptoDays", name: "Urlaubstage" },
        {
          value: "wagePerHour",
          name: "Stundenvergütung"
        },
        {
          value: "trialPeriodMonths",
          name: "Probemonate"
        },
        {
          value: "paymentOnAccount",
          name: "Akonto"
        },
        {
          value: "employeeSignatureLink",
          name: "Signaturlink MA"
        },
        {
          value: "contractType",
          name: "VertragsArt"
        }
      ]
    },
    {
      name: "Unit",
      value: "Unit",
      properties: [
        { value: "name", name: "Name" },
        { value: "email", name: "E-Mail" },
        { value: "address.place", name: "Ort" },
        {
          value: "phoneNumber",
          name: "Telefonnummer"
        }
      ]
    },
    {
      name: "Eingabefeld",
      value: "Input",
      properties: [{ value: "text", name: "Standard" }, { value: "date", name: "Datum" }]
    }
  ];
  if ($$props.open === void 0 && $$bindings.open && open !== void 0) $$bindings.open(open);
  if ($$props.template === void 0 && $$bindings.template && template !== void 0) $$bindings.template(template);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${validate_component(Modal, "Modal").$$render(
      $$result,
      {
        size: "xxl",
        title: "E-Mail Vorlage bearbeiten",
        open
      },
      {
        open: ($$value) => {
          open = $$value;
          $$settled = false;
        }
      },
      {
        default: () => {
          return `<form><div class="flex gap-3">${validate_component(Label, "Label").$$render($$result, { class: "space-y-2 flex-1" }, {}, {
            default: () => {
              return `<span data-svelte-h="svelte-15ueaex">Name</span> ${validate_component(Input, "Input").$$render(
                $$result,
                { required: true, value: template.name },
                {
                  value: ($$value) => {
                    template.name = $$value;
                    $$settled = false;
                  }
                },
                {}
              )}`;
            }
          })} ${validate_component(Label, "Label").$$render($$result, { class: "space-y-2 flex-1" }, {}, {
            default: () => {
              return `<span data-svelte-h="svelte-1cpjvx0">Betreff</span> ${validate_component(Input, "Input").$$render(
                $$result,
                { required: true, value: template.subject },
                {
                  value: ($$value) => {
                    template.subject = $$value;
                    $$settled = false;
                  }
                },
                {}
              )}`;
            }
          })} ${validate_component(Label, "Label").$$render($$result, { class: "space-y-2" }, {}, {
            default: () => {
              return `<span data-svelte-h="svelte-fsgv2u">Verfügbarkeit</span> ${validate_component(Select, "Select").$$render(
                $$result,
                {
                  required: true,
                  items: mailTemplateLevels,
                  value: template.level
                },
                {
                  value: ($$value) => {
                    template.level = $$value;
                    $$settled = false;
                  }
                },
                {}
              )}`;
            }
          })}</div> <div class="grid gap-3 grid-cols-2 mt-5"><div>${each(previewParts, (part) => {
            return `<!-- HTML_TAG_START -->${part.content}<!-- HTML_TAG_END -->`;
          })} </div> <div class="grid gap-5">${each(previewParts, (part) => {
            return `<textarea>${escape(part.content || "")}</textarea>`;
          })} <div>${validate_component(Button, "Button").$$render($$result, { class: "", size: "sm" }, {}, {
            default: () => {
              return `apply`;
            }
          })}</div></div></div> ${validate_component(Hr, "Hr").$$render($$result, {}, {}, {})} <div>${validate_component(Heading, "Heading").$$render($$result, { tag: "h3", class: "text-neutral-600" }, {}, {
            default: () => {
              return `Eingebettete Variablen`;
            }
          })} ${each(template.placeholders, (placeholder) => {
            return `<div class="grid gap-2 grid-cols-9 place-self-start text-neutral-600 items-center my-3">${validate_component(Card, "Card").$$render($$result, { class: "space-y-2 col-span-2" }, {}, {
              default: () => {
                return `${validate_component(InfoBox, "InfoBox").$$render(
                  $$result,
                  {
                    title: "Entity",
                    items: entities,
                    type: "select",
                    value: placeholder.entity
                  },
                  {
                    value: ($$value) => {
                      placeholder.entity = $$value;
                      $$settled = false;
                    }
                  },
                  {}
                )} ${placeholder.entity ? `${validate_component(InfoBox, "InfoBox").$$render(
                  $$result,
                  {
                    title: "Property",
                    items: entities.find((x) => x.value === placeholder.entity)?.properties,
                    type: "select",
                    value: placeholder.entityProperty
                  },
                  {
                    value: ($$value) => {
                      placeholder.entityProperty = $$value;
                      $$settled = false;
                    }
                  },
                  {}
                )}` : ``} `;
              }
            })} ${validate_component(ArrowKeyRight, "ArrowKeyRight").$$render($$result, { class: "w-6 place-self-center" }, {}, {})} ${validate_component(Card, "Card").$$render($$result, {}, {}, {
              default: () => {
                return `${validate_component(InfoBox, "InfoBox").$$render(
                  $$result,
                  {
                    title: "Default value",
                    value: placeholder.default
                  },
                  {
                    value: ($$value) => {
                      placeholder.default = $$value;
                      $$settled = false;
                    }
                  },
                  {}
                )} `;
              }
            })} ${validate_component(ArrowKeyRight, "ArrowKeyRight").$$render($$result, { class: "w-6 place-self-center" }, {}, {})} ${validate_component(Card, "Card").$$render($$result, { class: "space-y-2 col-span-2" }, {}, {
              default: () => {
                return `${validate_component(InfoBox, "InfoBox").$$render(
                  $$result,
                  {
                    title: "Formatter",
                    items: formatters,
                    type: "select",
                    value: placeholder.formatter
                  },
                  {
                    value: ($$value) => {
                      placeholder.formatter = $$value;
                      $$settled = false;
                    }
                  },
                  {}
                )} ${placeholder.formatter === "matcher" || placeholder.formatter === "link" ? `${validate_component(Textarea, "Textarea").$$render(
                  $$result,
                  {
                    placeholder: placeholder.formatter === "matcher" ? '{"key": "value"}' : "https://example.com?url={{value}}",
                    value: placeholder.matcher
                  },
                  {
                    value: ($$value) => {
                      placeholder.matcher = $$value;
                      $$settled = false;
                    }
                  },
                  {}
                )}` : ``} `;
              }
            })} ${validate_component(ArrowKeyRight, "ArrowKeyRight").$$render($$result, { class: "w-6 place-self-center" }, {}, {})} ${validate_component(Card, "Card").$$render($$result, {}, {}, {
              default: () => {
                return `${validate_component(InfoBox, "InfoBox").$$render(
                  $$result,
                  {
                    super_edit: writable(true),
                    title: "In Template",
                    value: placeholder.templateProperty
                  },
                  {
                    value: ($$value) => {
                      placeholder.templateProperty = $$value;
                      $$settled = false;
                    }
                  },
                  {}
                )} `;
              }
            })} </div>`;
          })} <div class="mt-5">${validate_component(Button, "Button").$$render($$result, {}, {}, {
            default: () => {
              return `Variable hinzufügen`;
            }
          })}</div></div> ${validate_component(Hr, "Hr").$$render($$result, {}, {}, {})} <div class="mt-5 flex gap-5 justify-end">${validate_component(Button, "Button").$$render($$result, { type: "submit" }, {}, {
            default: () => {
              return `Save`;
            }
          })} ${template.id ? `${validate_component(Button, "Button").$$render($$result, { type: "button", color: "alternative" }, {}, {
            default: () => {
              return `Save as copy`;
            }
          })}` : ``}</div></form>`;
        }
      }
    )}`;
  } while (!$$settled);
  $$unsubscribe_globalToast();
  return $$rendered;
});
const EmailTemplates = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $globalConfirm, $$unsubscribe_globalConfirm;
  $$unsubscribe_globalConfirm = subscribe(globalConfirm, (value) => $globalConfirm = value);
  let templates = [];
  let editModal = false;
  let search = "";
  let newTemplate = {
    id: null,
    name: "",
    subject: "",
    level: "",
    content: "",
    placeholders: []
  };
  const super_edit = writable(true);
  setContext("super_edit", super_edit);
  const fillEditor = (templateId) => {
    let templateIndex = templates.findIndex((x) => x.id === templateId);
    newTemplate = {
      id: templates[templateIndex].id,
      name: templates[templateIndex].name,
      subject: templates[templateIndex]?.subject,
      level: templates[templateIndex].level,
      content: templates[templateIndex].content,
      placeholders: templates[templateIndex].placeholders
    };
    editModal = true;
  };
  const deleteTemplate = async (templateId) => {
    let templateIndex = templates.findIndex((x) => x.id === templateId);
    $globalConfirm.confirm("Template wirklich löschen?", () => {
      retire("/email-templates/" + templates[templateIndex].id);
      templates = templates.filter((x, i) => i !== templateIndex);
    });
  };
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${validate_component(Search, "Search").$$render(
      $$result,
      { value: search },
      {
        value: ($$value) => {
          search = $$value;
          $$settled = false;
        }
      },
      {}
    )} ${validate_component(SortableTable, "SortableTable").$$render(
      $$result,
      {
        header: mailTemplates(fillEditor, deleteTemplate),
        data: templates.filter((x) => x.name.toLowerCase().includes(search.toLowerCase()))
      },
      {},
      {}
    )} ${editModal ? `${validate_component(EmailTemplateEditModal, "EmailTemplateEditModal").$$render(
      $$result,
      { template: newTemplate, open: editModal },
      {
        open: ($$value) => {
          editModal = $$value;
          $$settled = false;
        }
      },
      {}
    )}` : ``}`;
  } while (!$$settled);
  $$unsubscribe_globalConfirm();
  return $$rendered;
});
const MailjetTemplate = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let mailjetTemplates = [];
  let emailTemplates = [];
  let existingId = 0;
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `<aside class="grid grid-cols-2 gap-3">${validate_component(Label, "Label").$$render($$result, { class: "space-y-2" }, {}, {
      default: () => {
        return `<span data-svelte-h="svelte-1vfv6wo">Mailjet</span> ${validate_component(Select, "Select").$$render($$result, {}, {}, {
          default: () => {
            return `${each(mailjetTemplates, (template) => {
              return `<option${add_attribute("value", template.ID, 0)}>${escape(template.Name)}</option>`;
            })}`;
          }
        })}`;
      }
    })} ${validate_component(Label, "Label").$$render($$result, { class: "space-y-2" }, {}, {
      default: () => {
        return `<span data-svelte-h="svelte-8rydg7">Local</span> ${validate_component(Select, "Select").$$render(
          $$result,
          {
            placeholder: "Update existing",
            value: existingId
          },
          {
            value: ($$value) => {
              existingId = $$value;
              $$settled = false;
            }
          },
          {
            default: () => {
              return `<option${add_attribute("value", 0, 0)} data-svelte-h="svelte-5g0ytp">Neue Vorlage</option> ${each(emailTemplates, (template) => {
                return `<option${add_attribute("value", template.id, 0)}>${escape(template.name)}</option>`;
              })}`;
            }
          }
        )}`;
      }
    })}</aside> ${``}`;
  } while (!$$settled);
  return $$rendered;
});
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  return `${validate_component(Tabs, "Tabs").$$render($$result, { style: "underline" }, {}, {
    default: () => {
      return `${validate_component(TabItem, "TabItem").$$render($$result, { title: "Vertragsvorlagen", open: true }, {}, {
        default: () => {
          return `${validate_component(ContractTemplates, "ContractTemplates").$$render($$result, {}, {}, {})}`;
        }
      })} ${validate_component(TabItem, "TabItem").$$render($$result, { title: "Email Vorlagen" }, {}, {
        default: () => {
          return `${validate_component(EmailTemplates, "EmailTemplates").$$render($$result, {}, {}, {})}`;
        }
      })} ${validate_component(TabItem, "TabItem").$$render($$result, { title: "Import Mailjet Templates" }, {}, {
        default: () => {
          return `${validate_component(MailjetTemplate, "MailjetTemplate").$$render($$result, {}, {}, {})}`;
        }
      })}`;
    }
  })}`;
});
export {
  Page as default
};
//# sourceMappingURL=_page.svelte.js.map
